import React, { Component } from 'react';
import { safeParse } from '../utils';
const Parser = safeParse;
import { 
  CircleIcon,
  ChevronIcon2
} from './SVGIcons';

import TAOS from "./../Taos";
import Social from './Social'

class App extends Component {
  render() {

    const data = this.props?.data || {}
    const staff = data?.staff || {}
    const { showWindow } = this.props

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.86992 8.1525C6.79492 8.145 6.70492 8.145 6.62242 8.1525C4.83742 8.0925 3.41992 6.63 3.41992 4.83C3.41992 2.9925 4.90492 1.5 6.74992 1.5C8.58742 1.5 10.0799 2.9925 10.0799 4.83C10.0724 6.63 8.65492 8.0925 6.86992 8.1525Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.3075 3C13.7625 3 14.9325 4.1775 14.9325 5.625C14.9325 7.0425 13.8075 8.1975 12.405 8.25C12.345 8.2425 12.2775 8.2425 12.21 8.25" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3.12004 10.92C1.30504 12.135 1.30504 14.115 3.12004 15.3225C5.18254 16.7025 8.56504 16.7025 10.6275 15.3225C12.4425 14.1075 12.4425 12.1275 10.6275 10.92C8.57254 9.5475 5.19004 9.5475 3.12004 10.92Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.7549 15C14.2949 14.8875 14.8049 14.67 15.2249 14.3475C16.3949 13.47 16.3949 12.0225 15.2249 11.145C14.8124 10.83 14.3099 10.62 13.7774 10.5" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Наши сотрудники</div>
            </div>
          </div>
          <h2 className='font-medium mt-[20px] xl:mt-[30px] tracking-[-0.04em] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(staff?.title)}</h2>
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60'>{Parser(staff?.text)}</div>
          <div className='mt-[25px] grid grid-cols-2 xl:grid-cols-4 gap-[11px] xl:gap-[15px]'>
            {(staff?.items || []).map( ( elm ) => (
              <TAOS
                as="div"
                className="
                  p-[5px] bg-[#F5F7F9] rounded-[15px] xl:min-h-[441px]
                  duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
                "
                offset="300"
              >
              <img src={elm.image} width={277} height={336} alt={elm.name} className='w-full h-auto rounded-[19px]' />
              <div className='mt-[20px] px-[15px] text-[14px] xl:text-[16px] text-black/60'>{elm.position}</div>
              <div className='mt-[11px] px-[15px] text-[16px] xl:text-[18px] text-[#032432] mb-[15px] xl:mb-0'>{elm.name}</div>
              </TAOS>
            ) )}
            <TAOS
              as="div"
              className="
                col-span-2 xl:min-h-[424px] bg-cover rounded-[15px] p-[25px]
                duration-[300ms] taos:[transform:perspective(2500px)_rotateY(-100deg)] taos:invisible taos:[backface-visibility:hidden]
              "
              style={{
                backgroundImage: `url('${staff?.last_bg}')`
              }}
              offset="300"
            >
              <div className='flex flex-row-reverse xl:flex-col justify-between xl:items-start items-center xl:gap-[40px]'>
                <svg className='flex-none' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M29.3337 10.667V17.3337C29.3337 22.667 26.667 25.3337 21.3337 25.3337H20.667C20.2537 25.3337 19.8537 25.5337 19.6003 25.867L17.6003 28.5337C16.7203 29.707 15.2803 29.707 14.4003 28.5337L12.4003 25.867C12.187 25.5737 11.6937 25.3337 11.3337 25.3337H10.667C5.33366 25.3337 2.66699 24.0003 2.66699 17.3337V10.667C2.66699 5.33366 5.33366 2.66699 10.667 2.66699H16.0003" stroke="#009EE3" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M20.267 6.15946C19.827 4.83946 20.347 3.21279 21.787 2.75946C22.5336 2.53279 23.467 2.71946 24.0003 3.42612C24.507 2.69279 25.467 2.53279 26.2136 2.75946C27.6536 3.19946 28.1736 4.83946 27.7336 6.15946C27.0536 8.25279 24.667 9.33279 24.0003 9.33279C23.3336 9.33279 20.9736 8.26612 20.267 6.15946Z" stroke="#009EE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M21.3283 14.6667H21.3403" stroke="#009EE3" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M15.9943 14.6667H16.0063" stroke="#009EE3" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M10.6593 14.6667H10.6713" stroke="#009EE3" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div className='text-[14px] xl:text-[16px] px-[12px] inline-flex items-center gap-[5px] h-[35px] border border-[#797a7a] bg-white/5 rounded-full'>
                  <CircleIcon />
                  <div className='text-white'>Эксперты, которым доверяют</div>
                </div>
              </div>
              <h3 className='font-medium text-[16px] xl:text-[36px] mt-[21px] text-white tracking-[-0.04em] max-w-[700px] leading-none'>
                ХимАвангард — это команда профессионалов, <span className='text-white/60'>открытая к диалогу и решениям</span>
              </h3>
              <div className='mt-[20px] text-white/60 max-w-[571px] leading-none text-[14px] xl:text-[16px]'>
                Мы уверены: за каждым качественным продуктом стоит сильная команда. Если у вас есть вопросы, предложения по сотрудничеству или желание стать частью нашего коллектива — будем рады обратной связи.
              </div>
              <div className='flex items-center justify-between gap-[10px] xl:gap-[5px] mt-[28px] flex-col xl:flex-row'>
                <div className='flex w-full xl:w-auto items-center justify-between gap-[5px]'>
                  <div onClick={() => showWindow()} className='flex flex-1 xl:flex-auto items-center justify-center gap-[9px] h-[50px] px-[14px] bg-white text-black rounded-full cursor-pointer'>
                    <div>Связаться</div>
                    <ChevronIcon2 stroke="black" />
                  </div>
                  <Social social={data?.social || []} width={50} />
                </div>
                <div className='flex flex-col xl:flex-row w-full xl:w-auto text-center xl:text-start items-center justify-between gap-[5px]'>
                  <div className='text-white/60 hidden xl:block text-[14px]'>
                    Или свяжитесь<br />
                    по телефону
                  </div>
                  <div className='text-white/60 xl:hidden text-[12px]'>
                    Или свяжитесь по телефону
                  </div>
                  <a href={`tel:${data?.phone.replace(/[-()\s]/g, '')}`} className='flex items-center justify-center w-full xl:w-auto gap-[9px] h-[50px] px-[24px] bg-[#009EE3] text-white rounded-full cursor-pointer'>
                    <div>{data?.phone}</div>
                    <ChevronIcon2 stroke="white" />
                  </a>
                </div>
              </div>
            </TAOS>
          </div>
        </div>
      </div>
    );
  }
}

export default App;